module.exports = __webpack_public_path__ + "img/panneau-bois-half.c6561f5.svg";